import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-8 pb-10 sm:pt-14 sm:pb-20 items-center justify-center overflow-hidden bg-bg-main" data-id="element-192">
      {/* Grid background */}
      <div className="absolute inset-0 grid-bg opacity-40 pointer-events-none" data-id="element-193"></div>

      {/* Orange glows */}
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[500px] rounded-full blur-[120px] pointer-events-none" style={{
      background: 'rgba(242, 92, 37, 0.18)'
    }} data-id="element-194"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full blur-[100px] pointer-events-none hidden sm:block" style={{
      background: 'rgba(242, 92, 37, 0.12)'
    }} data-id="element-195"></div>

      {/* Top warning badge */}
      <div className="relative bg-primary/10 border border-primary/40 text-primary font-bold text-[10px] sm:text-xs uppercase px-3 py-1.5 sm:px-4 sm:py-2 rounded-sm mb-5 sm:mb-7 flex items-center gap-2 tracking-wider shadow-[0_0_20px_rgba(242,92,37,0.2)]" data-id="element-196">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-primary animate-pulse" data-id="element-197"></span>
        <span className="hidden sm:inline" data-id="element-198">
          🚨 ATTENZIONE COACH FUNCTIONAL STANCHI DI PASSARE LE SERATE A
          PROGRAMMARE ALLENAMENTI
        </span>
        <span className="sm:hidden" data-id="element-199">🚨 ATTENZIONE COACH FUNCTIONAL</span>
      </div>

      {/* Headline */}
      <h1 className="font-display relative font-bold max-w-5xl text-[32px] leading-[1.05] sm:text-6xl md:text-7xl mb-5 sm:mb-7 tracking-tight uppercase text-white" data-id="element-200">
        Risolvi mesi di classi Functional in{' '}
        <span className="text-primary relative inline-block" data-id="element-201">
          pochi minuti.
          <span className="absolute -bottom-1 left-0 w-full h-1 bg-primary" data-id="element-202"></span>
        </span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-sm sm:text-xl font-medium leading-relaxed mb-3 sm:mb-5 max-w-3xl mx-auto text-text-sec" data-id="element-203">
        Il sistema{' '}
        <span className="font-bold text-primary" data-id="element-204">"Apri e Allena"</span> con
        workout già pronti, progressioni intelligenti, mobility flow, classi
        women e protocolli professionali.
      </p>

      <p className="relative text-base sm:text-2xl font-bold text-white mb-6 sm:mb-10 max-w-2xl" data-id="element-205">
        Riprenditi il tuo tempo. Torna ad allenare con energia.
      </p>

      {/* Hero image */}
      <div className="relative w-full max-w-[360px] sm:max-w-[640px] md:max-w-[820px] mx-auto mb-6 sm:mb-10" data-id="element-206">
        <div className="absolute inset-0 blur-[80px] rounded-full hidden sm:block" style={{
        background: 'rgba(242, 92, 37, 0.25)'
      }} data-id="element-207"></div>
        <img src="https://cdn.magicpatterns.com/uploads/ddSo9XZUgbpKuHtXcpKViZ/ChatGPT_Image_25_may_2026,_13_14_03.png" alt="FUNCTIONAL PRONTO — IL SISTEMA COMPLETO con 6 Bonus Premium per Coach Functional Moderni" className="relative w-full h-auto object-contain drop-shadow-[0_25px_45px_rgba(242,92,37,0.35)]" width={1200} height={800} fetchPriority="high" loading="eager" decoding="async" data-id="element-208" />
      </div>

      <p className="relative font-display uppercase font-bold text-sm sm:text-xl text-white tracking-widest mb-2" data-id="element-209">
        FUNCTIONAL PRONTO — IL SISTEMA COMPLETO
      </p>
      <p className="relative text-xs sm:text-sm text-text-sec mb-6 sm:mb-8 uppercase tracking-wider" data-id="element-210">
        Sistema Professionale per Coach Functional Moderni
      </p>

      {/* Reviews */}
      <div className="relative flex flex-col items-center gap-3 mb-5 sm:mb-7" data-id="element-211">
        <div className="flex items-center gap-2" data-id="element-212">
          <span className="text-sm sm:text-lg text-secondary" data-id="element-213">⭐⭐⭐⭐⭐</span>
          <span className="text-xs sm:text-base font-medium text-text-sec" data-id="element-214">
            4.9/5 (+1.200 Recensioni Verificate)
          </span>
        </div>
        <span className="font-bold text-xs sm:text-sm px-4 py-1.5 rounded-sm border border-primary/40 bg-primary/10 text-primary uppercase tracking-wider" data-id="element-215">
          🔥 87 coach in Italia hanno scelto Functional Pronto oggi
        </span>
      </div>

      {/* CTA */}
      <a href="#pricing" onClick={() => {
      const w = window as any;
      if (w.fbq) {
        w.fbq('track', 'AddToCart', {
          content_name: 'Functional Pronto — Sistema Completo',
          content_type: 'product',
          value: 19,
          currency: 'EUR'
        });
      }
    }} className="relative btn-primary-pulse font-display font-bold uppercase tracking-wide text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-sm transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-cta-green hover:bg-cta-green-hover border border-white/10" data-id="element-216">
        🚀 SÌ! VOGLIO RISPARMIARE ORE DI PROGRAMMAZIONE
      </a>

      <p className="relative text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap text-text-sec uppercase tracking-wider" data-id="element-217">
        <span data-id="element-218">⚡ Accesso Immediato</span>
        <span data-id="element-219">•</span>
        <span data-id="element-220">🛡️ Garanzia 7 Giorni</span>
        <span data-id="element-221">•</span>
        <span data-id="element-222">💳 Pagamento Unico</span>
      </p>
    </section>;
}